/**
 * @generated SignedSource<<d6852b54dc6aa5cc1decec2d21a7680e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserAdminCreateGroupDeviceAcceptRequestAcceptMutation$variables = {
  deviceCode: string;
};
export type UserAdminCreateGroupDeviceAcceptRequestAcceptMutation$data = {
  readonly store: {
    readonly acceptSharedMobileDeviceAuthRequest: {
      readonly id: string;
    };
  };
};
export type UserAdminCreateGroupDeviceAcceptRequestAcceptMutation = {
  response: UserAdminCreateGroupDeviceAcceptRequestAcceptMutation$data;
  variables: UserAdminCreateGroupDeviceAcceptRequestAcceptMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deviceCode"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "deviceCode",
            "variableName": "deviceCode"
          }
        ],
        "concreteType": "SharedMobileDevice",
        "kind": "LinkedField",
        "name": "acceptSharedMobileDeviceAuthRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserAdminCreateGroupDeviceAcceptRequestAcceptMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserAdminCreateGroupDeviceAcceptRequestAcceptMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "73de646d49e7e0c586c644ae5c26f7b9",
    "id": null,
    "metadata": {},
    "name": "UserAdminCreateGroupDeviceAcceptRequestAcceptMutation",
    "operationKind": "mutation",
    "text": "mutation UserAdminCreateGroupDeviceAcceptRequestAcceptMutation(\n  $deviceCode: String!\n) {\n  store {\n    acceptSharedMobileDeviceAuthRequest(deviceCode: $deviceCode) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a2289c58b303ee71880c06036e6d6fe6";

export default node;
